import { useLocation, Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <div className="relative flex flex-col items-center justify-center min-h-[70vh] text-center px-4 pt-20">
        <div className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-200 select-none pointer-events-none z-0">
          404
        </div>
        <div className="relative z-10">
          <i className="ri-error-warning-line text-5xl text-primary-300 mb-4 block"></i>
          <h1 className="text-xl md:text-2xl font-semibold text-foreground-900 mt-6">This page has not been generated</h1>
          <p className="mt-2 text-sm text-foreground-400 font-mono">{location.pathname}</p>
          <p className="mt-4 text-base md:text-lg text-foreground-500">Tell me more about this page, so I can generate it</p>
          <Link
            to="/"
            className="inline-flex items-center gap-2 mt-8 px-7 py-3 bg-primary-500 text-white text-sm font-semibold rounded-full hover:bg-primary-600 transition-colors"
          >
            <i className="ri-home-line"></i>
            Back to Home
          </Link>
        </div>
      </div>
      <Footer />
    </div>
  );
}